import React from 'react'
import { CheckCircleOutline, Facebook, Instagram, YouTube, X } from '@mui/icons-material'
import './success.css'

const success = () => {
  return (
    <div className='success-wrapper'>
      <CheckCircleOutline style={{ color: '#37b983', fontSize: 80 }} />
      <h2 style={{ marginTop: '.5rem', color: '#37b983' }}>Registration complete!</h2>
      <p>
        Thank you for requesting a software demonstration. If you have provided a valid email or contact number, we will
        be in touch as soon as possible
      </p>
      <div className='social-media'>
        <section />
        <h4>Follow us on Social Media</h4>
        <a href='https://www.facebook.com/GemvisionCorp/' target='_blank' rel='noopener noreferrer'>
          <Facebook />
        </a>
        <a href='https://www.instagram.com/gemvisioncorp/' target='_blank' rel='noopener noreferrer'>
          <Instagram />
        </a>
        <a href='https://www.youtube.com/GemvisionCorp' target='_blank' rel='noopener noreferrer'>
          <YouTube />
        </a>
        <a href='https://twitter.com/GemvisionCorp' target='_blank' rel='noopener noreferrer'>
          <X />
        </a>
      </div>
    </div>
  )
}

export default success
